import { render } from "./SendGridIntegrationSettings.vue?vue&type=template&id=5b5eb90b"
import script from "./SendGridIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./SendGridIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__